'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'star';
var width = 576;
var height = 512;
var aliases = [61446,11088];
var unicode = 'f005';
var svgPathData = 'M528.5 171.5l-146.4-21.29l-65.43-132.4C310.9 5.971 299.4-.002 287.1 0C276.6 0 265.1 5.899 259.3 17.8L193.8 150.2L47.47 171.5C21.2 175.3 10.68 207.6 29.72 226.1l105.9 102.1L110.6 474.6C107 495.3 123.6 512 142.2 512c4.932 0 10.01-1.172 14.88-3.75L288 439.6l130.9 68.7c4.865 2.553 9.926 3.713 14.85 3.713c18.61 0 35.21-16.61 31.65-37.41l-25.05-145.5l105.9-102.1C565.3 207.6 554.8 175.3 528.5 171.5zM407.4 326.2l26.39 153.7l-138.4-72.6c-4.656-2.443-10.21-2.442-14.87 .0008l-138.4 72.66l27.91-162.1l-117.9-114.7l154.7-22.51C211.1 179.9 216.5 176.6 218.8 171.9L288 32l69.21 139.9c2.333 4.716 6.834 7.983 12.04 8.74l154.7 22.49l-111.1 108.9C408.2 315.7 406.5 320.1 407.4 326.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStar = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;


//////////////////
// WEBPACK FOOTER
// ./~/@fortawesome/pro-light-svg-icons/faStar.js
// module id = wyaz
// module chunks = 0